import { render, staticRenderFns } from "./hqglCarRegInsuranceFee.vue?vue&type=template&id=2c52f7be&scoped=true&"
import script from "./hqglCarRegInsuranceFee.vue?vue&type=script&lang=js&"
export * from "./hqglCarRegInsuranceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52f7be",
  null
  
)

export default component.exports